export default "__VITE_ASSET__Cuj14Xxf__"